import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { useStyleContextState } from '../../../../../../ReactSharedScripts/modules/styleContext';
import { AngleRightLarge } from '../../../../../../ReactSharedScripts/components/Icons/AngleRightLarge';
import { gray } from '../../../../../../ReactSharedScripts/components/Color';

type SpreadsheetBodyRowItemNavigationProps = {
	className?: string;
	onClick?: () => unknown;
	hasNavigationIcon?: boolean;
	isEmpty?: boolean;
	disabled?: boolean;
};

export const SpreadsheetBodyRowItemNavigation: FC<React.PropsWithChildren<SpreadsheetBodyRowItemNavigationProps>> = ({
	className,
	children,
	onClick,
	hasNavigationIcon = true,
	isEmpty = false,
	disabled = false,
}) => {
	const { mainColor } = useStyleContextState();
	const iconColor = disabled ? gray[4] : mainColor;

	const handleComponentClick = () => {
		if (disabled || typeof onClick === 'undefined') {
			return;
		}

		onClick();
	};

	const componentClasses = classNames(
		classes.bodyRowItemNavigation,
		{
			[classes.bodyRowItemNavigation_hasAction]: !disabled && typeof onClick !== 'undefined',
			[classes.bodyRowItemNavigation_hasBorderLeft]: !isEmpty,
		},
		className,
	);

	return (
		<div
			onClick={handleComponentClick}
			className={componentClasses}
		>
			{hasNavigationIcon && !isEmpty && <AngleRightLarge fill={iconColor} />}
			{!isEmpty && children}
		</div>
	);
};
